import {ServiceSubjectItem} from './ServiceSubjectItem';
import {Product} from './Product';
import {Solution} from './Solution';
import {FileManager} from '../../shared/Models/FileManager';

export class ServiceSubject {
  public id: number;
  public name?: string;
  public description?: string;
  public solution?: number;
  public status: boolean;
  public position: number;
  public translations: any;
  public nameObj?: any;
  public descriptionObj?: any;
  public serviceSubjectItems?: ServiceSubjectItem[];
  public solutions?: Solution[];
  public products: Array<Product> = [];
  public thumbnail: FileManager | number;
  public attachments: Array<FileManager> | Array<number>;
}
